import _ from 'lodash';

/* @ngInject */
export default function GasMeterPanelService($sails, $q, $log) {
  const service = this;

  /**
   * Public Variables
   */
  service.gasMeterPanelModel = {};
  const gasModel = service.gasMeterPanelModel;

  /**
   * Public Methods
   */
  service.getLatestEvent = getLatestEvent;
  service.getModel = getModel;
  service.updateModelFromEvent = updateModelFromEvent;
  service.updateLatestReadings = updateLatestReadings;
  service.deleteModel = deleteModel;


  function getLatestEvent(equipment, { id: panel }) {
    gasModel[panel] = gasModel[panel] || {};
    gasModel[panel][equipment.id] = gasModel[panel][equipment.id] || {};

    const now = Date.now();
    const days = 7;
    const hours = 24;
    const minutes = 60;
    const thou = 1000;
    const then = now - (days * hours * minutes * minutes * thou);
    const eventName = 'sensors/regularUpdate';


    // get the event data
    return $sails
      .get(`/event/dataInPeriodForGraphing/${equipment.id}?startDate=${then}&endDate=${now}&eventName=${eventName}`)
      .then(({ data: payload }) => {
        if (payload.events && payload.events.length) {
          // latest event
          updateLatestReadings(panel, equipment.id, payload.events[payload.events.length - 1]);
        }
        return equipment.id;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getModel(panelId) {
    gasModel[panelId] = gasModel[panelId] || {};
    return gasModel[panelId];
  }

  function updateModelFromEvent(panelId, eventObj) {
    const { equipment } = eventObj;
    gasModel[panelId] = gasModel[panelId] || {};
    gasModel[panelId][equipment.id] = gasModel[panelId][equipment.id] || {};

    updateLatestReadings(panelId, equipment.id, eventObj);
  }


  function updateLatestReadings(panelId, equipmentId, { data: eveData }) {
    if (panelId && equipmentId && eveData) {
      _.forEach(eveData, (val, key) => {
        if (key !== 'media') {
          // /event/dataInPeriodForGraphing downsamples dense windows, returning each reading as a
          // [min, avg, max] triple instead of a scalar. These values are rendered with `| number`,
          // which yields N/A for an array, so keep the middle (average) component.
          gasModel[panelId][equipmentId][key] = _.isArray(val) ? val[1] : val;
        }
      });
    }
  }

  /*
    * deletes all data from model
    */
  function deleteModel() {
    service.gasMeterPanelModel = {};
  }
}
